import ParentService from '@/service/ParentService.js';

export default class UtilsService extends ParentService {
   list_icons() {
      const url = `${super.baseUrl}utils/svg_list`;
      return super.customGet(url, {});
   }
}
